import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { mergeRedirectTarget } from "./sectionTabs";

// Old page URL -> its tab in a merged section. Keeps any other query params
// and the hash, so bookmarks and shared links keep working.
export default function SectionRedirect({ to }) {
  const location = useLocation();
  return <Navigate to={mergeRedirectTarget(to, location.search, location.hash)} replace />;
}
